import { useEffect, useMemo, useState } from "react";
import { Box, Stack, TextField, Button, Typography } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";


import BreadcrumbsBar from "../../../../../component/common/BreadcrumbsBar";
//import PageHeader from "../../../../component/common/PageHeader";

import ReportContainer from "../../../component/ReportContainer";
import ReportHeader from "../../../component/ReportHeader";
import ReportToolbar from "../../../component/ReportToolbar";
import ReportTitle from "../../../component/ReportTitle";
import ReportActions from "../../../component/ReportActions";
import ReportLoading from "../../../component/ReportLoading";
import ReportNoData from "../../../component/ReportNoData";
import { MenuItem } from "@mui/material";
import WGRViewer from "./caSViewer";
import { costAnalysisProcedure } from "../../../../../services/reportService";
import generateWGRPDF from "./pdfreport/caSgeneratePDF";

import { useLocation } from "react-router-dom";

import SearchIcon from "@mui/icons-material/Search";
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export default function DSAPage() {





  const location = useLocation();

  const report = location.state || {
    reportType: "DSA",
    title: "Divisional Allocation Summery",
  };

  const { reportType, title } = report;

  const today = new Date();



  const month = location.state.month;
  const year = location.state.year;




  const [rows, setRows] = useState([]);

  const [loading, setLoading] = useState(false);

  const monthName = useMemo(
    () => months[month - 1],
    [month]
  );

  const loadReport = async () => {
    try {
      setLoading(true);

      const res = await costAnalysisProcedure(month, year);

      setRows(res.data.data || []);

      
    } catch (err) {
      console.error(err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  const handleRefresh = () => {
    loadReport();
  };

  const handlePrint = () => {
    window.print();

    setTimeout(() => {
      setRows([]);
    }, 500);
  };



  /*
      Number(row["DIRECT LABOUR"] || 0) +
              Number(row["ACTUAL ON COST LABOUR"] || 0);
     */
//   const grandTotal = useMemo(() => {
//   return rows.reduce(
//     (sum, row) => {
//       const direct = Number(row["DIRECT LABOUR"] || 0);
//       const oncost = Number(row["ACTUAL ON COST LABOUR"] || 0);

//       return {
//         direct: sum.direct + direct,
//         oncost: sum.oncost + oncost,
//         total: sum.total + direct + oncost,
//       };
//     },
//     {
//       direct: 0,
//       oncost: 0,
//       total: 0,
//     }
//   );
// }, [rows]);


const grandTotal = useMemo(() => {
    return rows.reduce(
      (sum, row) => {

        const actualL = Number(row["ACTUAL ON COST LABOUR"] || 0);
        const distL = Number(row["DISTRIBUTED ON COST LABOUR"] || 0);
        const ou_L = actualL - distL;
        const actualS = Number(row["ACTUAL ON COST STORE"] || 0);
        const distS = Number(row["DISTRIBUTED ON COST STORE"] || 0);
        const ou_S = actualS - distS;


        return {
          actual_L: sum.actual_L + actualL,
          dist_L: sum.dist_L + distL,
          ou_LL: sum.ou_LL + ou_L,
          actual_S: sum.actual_S + actualS,
          dist_S: sum.dist_S + distS,
          ou_SS: sum.ou_SS + ou_S,

        };
      },
      {
        actual_L: 0,
        dist_L: 0,
        ou_LL: 0,
        actual_S: 0,
        dist_S: 0,
        ou_SS: 0,






      }
    );
  }, [rows]);

  const handlePdf = () => {
    generateWGRPDF(
      reportType,
      title,
      grandTotal,
      rows,
      "",
      monthName,

      year
    );
  };

  const handleExcel = () => {
    console.log("Generate Excel");
  };


  useEffect(() => {
    // Optional: Clear previous report
    setRows([]);

    // Load report if you want automatically
    loadReport();

  }, [reportType]);




  return (
    <Box >

      <BreadcrumbsBar page={title} />


      {/* Search Panel */}




      {/* Report */}

      <ReportContainer>


        <ReportToolbar>

          <ReportTitle
            title={title}
            subtitle={`${monthName} ${year}`}
          />

          <Box className="no-print">
            <ReportActions
              onRefresh={handleRefresh}
              onPrint={handlePrint}
              onPdf={handlePdf}
              onExcel={handleExcel}
            />
          </Box>



        </ReportToolbar>

        {loading ? (
          <ReportLoading />
        ) : rows.length === 0 ? (
          <ReportNoData text="Click Generate to view report." />
        ) : (
          <WGRViewer
            rows={rows}
            grandTotal={grandTotal}
            summary=""
          />
        )}

      </ReportContainer>

    </Box>
  );
}